<script setup lang="ts">
import { markRaw } from "vue"
import { Check, Clock, X } from "@lucide/vue"
import { useI18n } from "vue-i18n"
import { Badge } from "@/shared/ui"
import type { BadgeVariants } from "@/shared/ui"

const props = defineProps<{
  status: "scheduled" | "completed" | "cancelled"
  size?: BadgeVariants["size"]
}>()

const { t } = useI18n()

const config = {
  scheduled: { variant: "info" as const, icon: markRaw(Clock), labelKey: "journal.status.scheduled" },
  completed: { variant: "success" as const, icon: markRaw(Check), labelKey: "journal.status.completed" },
  cancelled: { variant: "danger" as const, icon: markRaw(X), labelKey: "journal.status.cancelled" },
} satisfies Record<typeof props.status, { variant: "info" | "success" | "danger"; icon: object; labelKey: string }>
</script>

<template>
  <Badge
    :variant="config[props.status].variant"
    :size="props.size"
    class="gap-1"
  >
    <component
      :is="config[props.status].icon"
      :size="props.size === 'sm' ? 9 : 12"
      aria-hidden="true"
    />
    {{ t(config[props.status].labelKey) }}
  </Badge>
</template>
